// extracted by css-extract-rspack-plugin
export default {"container":"select__container___MND60"};